import { DateTime } from "luxon";

export function formatCompactAge(iso: string, now: DateTime): string {
  const start = DateTime.fromISO(iso);
  if (!start.isValid) return "";
  const minutes = Math.max(0, Math.floor(now.diff(start, "minutes").minutes));
  const days = Math.floor(minutes / (60 * 24));
  if (days >= 99) return "99+ day";
  if (days >= 1) return `${days}d`;
  const hours = Math.floor(minutes / 60);
  if (hours >= 1) return `${hours}h`;
  return `${Math.max(1, minutes)}m`;
}

export function formatShortDate(iso: string | null): string {
  if (!iso) return "";
  const date = DateTime.fromISO(iso);
  return date.isValid ? date.toFormat("LLL d") : "";
}
